import { Navigate } from "react-router-dom";
import { useSession } from "./context/SessionContext";

export default function SessionGate({ children }) {
  const { sessionId, sessionReady } = useSession();

  if (!sessionReady) {
    return <div className="text-center mt-5">Loading...</div>;
  }

  if (!sessionId) {
    return <Navigate to="/admin/select-session" replace />;
  }

  return children;
}
